export default "__VITE_ASSET__DBFvL6s7__"